import { getDebugState, toggleBackendDictionaryKeys, toggleDictionaryKeys } from '@store/debugger';

export function triggerDictionaryKeys() {
    toggleDictionaryKeys();
    window.location.reload();
}

export function triggerBackendDictionaryKeys() {
    toggleBackendDictionaryKeys();
    setDebugOnQueryString();
    window.location.reload();
}

export function setDebugOnQueryString() {
    const { showBackendDictionaryKeys } = getDebugState();

    const QUERY_STRING_PARAMETER = 'debug';
    const url = window.location.pathname;
    const searchParams = new URLSearchParams(window.location.search);

    if (showBackendDictionaryKeys) {
        searchParams.set(QUERY_STRING_PARAMETER, showBackendDictionaryKeys.toString());
    } else {
        searchParams.delete(QUERY_STRING_PARAMETER);
    }

    const searchString = searchParams.toString() ? `?${searchParams.toString()}` : '';

    history.replaceState(null, '', url + searchString);
}
